const state= {};
const getters = {};
const actions = {
    async getAwaitingApproval({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/awaiting-approval`, { params: params })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getAwaitingApprovalBoxTotal({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/awaiting-approval/total`, { params: params })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async createItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/awaiting-approval`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    }
}

const mutations = {};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
